import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Sparkles, CheckCircle2, Copy } from "lucide-react";

export default function SalesRegister() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", bank_name: "", bank_account: "" });
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email) { toast.error("Nama, HP, email wajib"); return; }
    setLoading(true);
    try {
      const r = await api.post("/sales/register", form);
      setCode(r.data.referral_code);
      toast.success("Sales terdaftar!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal");
    }
    setLoading(false);
  };

  const copy = () => {
    navigator.clipboard.writeText(code);
    toast.success("Kode disalin");
  };

  if (code) {
    const inviteLink = `${window.location.origin}/register?ref=${code}`;
    return (
      <div className="tech-grid min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
        <Card className="glass glow-border bg-transparent rounded-2xl p-8 w-full max-w-md text-center fade-up">
          <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-4"/>
          <h1 className="font-display text-2xl font-bold text-white">Selamat! Anda kini Sales Freelance</h1>
          <p className="text-slate-400 mt-2">Kode referal Anda:</p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <div data-testid="sales-referral-code" className="font-mono-metric text-2xl font-bold text-cyan-300 bg-cyan-500/10 border border-cyan-500/40 rounded-lg px-6 py-3">{code}</div>
            <Button data-testid="sales-copy-code" size="icon" onClick={copy} className="bg-slate-800 hover:bg-slate-700"><Copy className="w-4 h-4"/></Button>
          </div>
          <div className="mt-6 bg-slate-900/60 border border-slate-700 rounded-lg p-3 text-xs font-mono-metric text-slate-300 break-all">
            {inviteLink}
          </div>
          <p className="text-xs text-slate-500 mt-3">Bagikan kode / link ini ke calon mitra. Anda otomatis dapat fee 0,5% dari setiap transaksi mereka.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="tech-grid min-h-[calc(100vh-4rem)] py-10 px-4">
      <div className="max-w-lg mx-auto fade-up">
        <div className="text-center mb-6">
          <div className="pill-cyan mx-auto w-fit mb-3"><Sparkles className="w-3 h-3"/> SALES FREELANCE</div>
          <h1 className="font-display text-3xl font-bold text-white">Daftar Sales Freelance</h1>
          <p className="text-slate-400 text-sm mt-2">Fee 0,5% dari setiap transaksi mitra referal Anda. Tanpa gaji tetap.</p>
        </div>
        <Card className="glass glow-border bg-transparent rounded-2xl p-6 sm:p-8">
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">Nama Lengkap</Label>
              <Input data-testid="sales-name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">No. HP</Label>
                <Input data-testid="sales-phone" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
              </div>
              <div>
                <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">Email</Label>
                <Input data-testid="sales-email" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">Bank</Label>
                <Input data-testid="sales-bank" value={form.bank_name} onChange={e=>setForm({...form,bank_name:e.target.value})} placeholder="BCA, Mandiri, BSI…" className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
              </div>
              <div>
                <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">No. Rekening</Label>
                <Input data-testid="sales-rekening" value={form.bank_account} onChange={e=>setForm({...form,bank_account:e.target.value})} className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11 font-mono-metric"/>
              </div>
            </div>
            <Button data-testid="sales-submit" type="submit" disabled={loading} className="w-full h-11 bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold">
              {loading ? "Mendaftarkan..." : "Daftar & Dapatkan Kode Referal"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
